<div class="home">
  <app-hero></app-hero>
  <app-about-us></app-about-us>
  <app-our-services></app-our-services>
  <app-slider-updated></app-slider-updated>
  <app-testimonials></app-testimonials>
  <app-contact-us></app-contact-us>
</div>
